import { Controller } from "@hotwired/stimulus"

// SweetAlert summary before confirm when any included list already has entries.
// Each list card carries its existing entry count (computed on page load) and its "Category - Stat" label.
export default class extends Controller {
  static targets = ["listCard"]

  confirmReplace(event) {
    if (this.element.dataset.replaceConfirmed === "true") {
      return
    }

    const replacements = this.replacementSummaries()
    if (replacements.length === 0) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    const summary = replacements.join("; ")
    const text = `Confirming replaces these lists and wipes any auto-generated holders: ${summary}.`

    if (typeof window.Swal === "undefined") {
      if (window.confirm(`Replace existing lists?\n\n${text}`)) {
        this.element.dataset.replaceConfirmed = "true"
        this.element.requestSubmit()
      }
      return
    }

    window.Swal.fire({
      title: "Replace existing lists?",
      text: text,
      showCancelButton: true,
      confirmButtonText: "Yes",
      keydownListenerCapture: true,
      confirmButtonAriaLabel: "Confirm replace",
      cancelButtonText: "Cancel",
      cancelButtonAriaLabel: "Cancel replace",
      customClass: {
        title: "color-fanword-black font-fanword-regular",
        confirmButton: "btn btn-sm px-4 py-2 text-decoration-none border-0 border-fanword-positive bg-fanword-positive color-fanword-black fanword-border-radius",
        cancelButton: "btn btn-sm px-4 py-2 text-decoration-none fanword-border bg-fanword-white color-fanword-black fanword-border-radius"
      }
    }).then((result) => {
      if (!result.isConfirmed) {
        return
      }

      this.element.dataset.replaceConfirmed = "true"
      this.element.requestSubmit()
    })
  }

  replacementSummaries() {
    const summaries = []

    this.listCardTargets.forEach((listCard) => {
      if (!this.listIncluded(listCard)) {
        return
      }

      const entryCount = Number(listCard.dataset.recordBookImportReviewExistingCount || 0)
      if (entryCount <= 0) {
        return
      }

      const label = listCard.dataset.recordBookImportReviewLabel || "Untitled list"
      const entryWord = entryCount === 1 ? "entry" : "entries"
      summaries.push(`"${label}" (${entryCount} ${entryWord})`)
    })

    return summaries
  }

  listIncluded(listCard) {
    const includeCheckbox = listCard.querySelector("[data-record-book-import-review-include]")
    return includeCheckbox ? includeCheckbox.checked : true
  }
}
